module.exports = __webpack_public_path__ + "static/media/logo-사고링크@2x.d67a28c5.png";